import { Magazine, MagazineGroup } from './variants';
import { getMagazineVariant } from './utils/getMagazineVariant';
import type { MagazineCollectionProps, MagazineItem } from './types';
import type { MagazineNode, GroupedMagazineNode } from 'data-layer';
import './styles.css';

function isGroupedMagazineNode(magazine: MagazineItem): magazine is GroupedMagazineNode {
  return !Array.isArray(magazine) && magazine.transformerType === 'GroupedMagazineTransformer';
}

function isMagazineNodeArray(magazine: MagazineItem): magazine is MagazineNode[] {
  return Array.isArray(magazine);
}

function MagazineCollection(props: MagazineCollectionProps) {
  const { device, magazines } = props;
  const isMobile = device === 'mobile';

  return (
    <>
      {magazines.map((magazine, index) => {
        const key = `magazine-collection-${index}`;

        if (isGroupedMagazineNode(magazine)) {
          return <MagazineGroup key={key} magazines={[magazine]} groupIndex={index} device={device} />;
        }

        if (isMagazineNodeArray(magazine)) {
          return <MagazineGroup key={key} magazines={magazine} groupIndex={index} device={device} />;
        }

        return (
          <Magazine
            key={magazine.sys.id}
            {...magazine}
            contentVariant={getMagazineVariant(index)}
            isMobile={isMobile}
            device={device}
          />
        );
      })}
    </>
  );
}

export { MagazineCollection };
